import { useApiQuery } from 'grabbitbot-legacy-ui'
import { wnfClient } from '../api'
import type { DepositableCoin } from '../api/types'

/** The coins test funds can be deposited / withdrawn in, from the API (the
 * single source — the UI has no hard-coded coin list or minimum). */
export function useDepositableCoins() {
  const q = useApiQuery(() => wnfClient.searchDepositableCoins(), [])
  const coins: DepositableCoin[] = q.data ?? []
  return { coins, loading: q.loading, error: q.error, find: (coin: string) => coins.find((c) => c.coin === coin) }
}
